import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { px } from 'styled-system';
import Box from '../Box';
import { useThemeDefaults } from '../utils';

var contentPaddingX = function contentPaddingX(theme) {
  return [theme.responsiveASC.sm.paddingX, theme.responsiveASC.md.paddingX, theme.responsiveASC.lg.paddingX, theme.responsiveASC.xl.paddingX];
};

var Content = useThemeDefaults(function (_ref) {
  var theme = _ref.theme;
  return {
    pl: contentPaddingX(theme),
    pr: contentPaddingX(theme),
    ml: "auto",
    mr: "auto",
    width: "100%",
    maxWidth: px(theme.responsiveASC.xl.contentWidth)
  };
}, Box);
Content.propTypes = _objectSpread({}, Box.propTypes);
export default Content;